module.exports = __webpack_public_path__ + "static/img/4areaA_14.d676ad8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_14.png
// module id = 900
// module chunks = 1